import React, { useState, useEffect } from "react";
import { getAppUrl } from "../utils/utm";

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (isOpen) {
        setIsOpen(false);
      }
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isOpen]);

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  // Prevent body scroll when drawer is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  const appUrl = getAppUrl();

  return (
    <div 
      className={`transition-all duration-500 ${scrolled ? "bg-black/95 shadow-lg" : "bg-transparent"}`}
    >
      <div className="container mx-auto">
        <nav
          className={`relative flex items-center justify-between py-4 px-4 lg:px-20`}
        >
          <div className="flex items-center space-x-2">
            <a href="#hero">
              <img
                src="logo.png"
                alt="Logo"
                className="h-[40px] w-[40px] lg:h-[70px] lg:w-[70px] transition-transform duration-300 hover:scale-110"
              />
            </a>
            <span className={`text-[18px] md:text-[28px] font-normal transition-colors duration-300 ${scrolled ? "text-white" : "text-black"}`}>
              <a href="#hero">
                nudgie <span className="font-bold">AI</span>
              </a>
            </span>
          </div>
          <div className="hidden lg:flex items-center space-x-6 xl:space-x-8">
            <a
              href="#how-it-works"
              className={`text-[18px] font-medium px-4 py-2 rounded-full transition-all duration-300 ${scrolled ? "text-gray-200 hover:text-[#AFD24F] hover:bg-[#AFD24F]/15" : "text-gray-800 hover:text-[#AFD24F] hover:bg-[#F2FCDA]"}`}
            >
              How it Works
            </a>
            {/* <a
              href="#demo-video-title"
              className={`text-[18px] font-medium px-4 py-2 rounded-full transition-all duration-300 ${scrolled ? "text-gray-200 hover:text-[#AFD24F] hover:bg-[#AFD24F]/15" : "text-gray-800 hover:text-[#AFD24F] hover:bg-[#F2FCDA]"}`}
            >
              Demo
            </a> */}
            <a
              href="#features"
              className={`text-[18px] font-medium px-4 py-2 rounded-full transition-all duration-300 ${scrolled ? "text-gray-200 hover:text-[#AFD24F] hover:bg-[#AFD24F]/15" : "text-gray-800 hover:text-[#AFD24F] hover:bg-[#F2FCDA]"}`}
            >
              Features
            </a>
            <a
              href="#faqs"
              className={`text-[18px] font-medium px-4 py-2 rounded-full transition-all duration-300 ${scrolled ? "text-gray-200 hover:text-[#AFD24F] hover:bg-[#AFD24F]/15" : "text-gray-800 hover:text-[#AFD24F] hover:bg-[#F2FCDA]"}`}
            >
              FAQ
            </a>
            {/* <a
              href={appUrl}
              className="ml-2 px-8 py-2 rounded-full border-2 border-[#8ABB01] transition-all duration-300 font-semibold transform hover:scale-105 text-white bg-black hover:bg-[#8ABB01] hover:text-black"
            >
              Try Nudgie
            </a> */}
          </div>
          <div className="flex lg:hidden items-center gap-2">
            {/* <a
              href={appUrl}
              className="px-4 py-2 text-[14px] rounded-full border-2 border-[#8ABB01] font-semibold text-white bg-black hover:bg-[#8ABB01] hover:text-black transition-all duration-300"
            >
              Try Nudgie
            </a> */}
            <button
              onClick={toggleDrawer}
              className="p-2 text-white bg-black rounded-full"
            >
              <svg
                stroke="currentColor"
                fill="none"
                strokeWidth="2"
                viewBox="0 0 24 24"
                strokeLinecap="round"
                strokeLinejoin="round"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M4 6h16"></path>
                <path d="M7 12h13"></path>
                <path d="M10 18h10"></path>
              </svg>
            </button>
          </div>
        </nav>
      </div>
      
      {/* Mobile Drawer Overlay */}
      <div
        className={`fixed inset-0 bg-black bg-opacity-50 z-[9998] lg:hidden ${
          isOpen ? "block" : "hidden"
        }`}
        onClick={toggleDrawer}
      ></div>

      {/* Mobile Drawer */}
      <div
        className={`fixed top-0 left-0 w-64 h-full shadow-lg z-[100000] transform ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out lg:hidden`}
        style={{ backgroundColor: "black" }}
      >
        <div className="p-6">
          <button
            onClick={toggleDrawer}
            className="absolute top-4 right-4 text-white p-2"
          >
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
          <div className="flex items-center space-x-2 mb-8">
            <img src="logo.png" alt="Logo" className="h-[40px] w-[40px]" />
            <span className="text-white text-[20px]">
              nudgie <span className="font-bold">AI</span>
            </span>
          </div>
          <div className="flex flex-col gap-4">
            <a
              href="#about-section"
              className="text-gray-200 text-[18px] font-medium px-4 py-2 rounded-full transition-all duration-300 hover:text-[#AFD24F] hover:bg-[#AFD24F]/15"
              onClick={toggleDrawer}
            >
              About
            </a>
            {/* <a
              href="#demo-video-section"
              className="text-gray-200 text-[18px] font-medium px-4 py-2 rounded-full transition-all duration-300 hover:text-[#AFD24F] hover:bg-[#AFD24F]/15"
              onClick={toggleDrawer}
            >
              Demo
            </a> */}
            <a
              href="#features"
              className="text-gray-200 text-[18px] font-medium px-4 py-2 rounded-full transition-all duration-300 hover:text-[#AFD24F] hover:bg-[#AFD24F]/15"
              onClick={toggleDrawer}
            >
              Features
            </a>
            <a
              href="#how-it-works"
              className="text-gray-200 text-[18px] font-medium px-4 py-2 rounded-full transition-all duration-300 hover:text-[#AFD24F] hover:bg-[#AFD24F]/15"
              onClick={toggleDrawer}
            >
              How it Works
            </a>
            <a
              href="#faq-section"
              className="text-gray-200 text-[18px] font-medium px-4 py-2 rounded-full transition-all duration-300 hover:text-[#AFD24F] hover:bg-[#AFD24F]/15"
              onClick={toggleDrawer}
            >
              FAQs
            </a>

            {/* <a
              href={appUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 px-4 py-2 text-center rounded-full bg-[#8ABB01] text-black font-semibold hover:bg-white transition-colors"
            >
              Launch App
            </a> */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Navbar;